import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 6000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userToken = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN)
    );
    config.headers = {
      Authorization: `Bearer ${userToken}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      // "Access-Token": `${tokenOffLine}`
    };
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.data.status_code === 401) {
      localStorage.removeItem(
        process.env.REACT_APP_LOCAL_STORAGE_KEY_USER_DATA
      );
      localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
